import { useState } from 'react';
import { Box, Grid } from '@mui/material';
import theme from 'theme';
import EduBudgetRequestsTable from './EduBudgetRequestsTable';

const EduBudgetRequestsView = () => {
  const [requests, setRequests] = useState([]);

  return (
    <Box sx={{ padding: theme.spacing(4) }}>
      <Grid
        size={{
          lg: 12,
          md: 12,
          xl: 12,
          xs: 12,
        }}
      >
        <EduBudgetRequestsTable requests={requests} setRequests={setRequests} />
      </Grid>
    </Box>
  );
};

export default EduBudgetRequestsView;
